import { Router } from 'types/definitions'
import { validate as isValidUUID } from 'uuid'

import PasswordResetViewModel from 'iam/components/PasswordReset/PasswordResetViewModel'
import { task } from 'mobx-task'
import { UserAPI } from 'iam/API'

export default class CompleteRegistrationViewModel {
  /*
   * Password reset view model.
   */
  passwordResetVM: PasswordResetViewModel

  constructor(
    private userApi: UserAPI,
    private router: Router,
  ) {
    this.passwordResetVM = new PasswordResetViewModel(this.userApi, this.router)
  }

  /*
   * Activates the complete registration view model.
   */
  activate = task(async (passwordRequestId: string | undefined) => {
    if (!passwordRequestId || !isValidUUID(passwordRequestId)) {
      throw new Error('Invalid password request id')
    }

    const result =
      await this.userApi.getResetPasswordRequestById(passwordRequestId)

    this.passwordResetVM.activate(result.id, result.email)
  })
}
